import React from "react";
import { Link } from "gatsby";

import NavigationOverlay from '../common/navigation-overlay';
import SearchOverlay from '../search/search-overlay';
import ShoppingBag from '../shop/shopping-bag';
import {
  MenuSvg,
  SearchSvg,
} from '../common/svg';
import SocialIcons from '../common/social-icons';

import "../../styles/site-header.scss";
import masthead from "../../../images/pdr-logo_2x.png";
import PDRCircles from '../../../images/pdr-circles.png';

class SiteHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      navigationExpanded: false,
      searchExpanded: false,
    };

    this.searchOverlayFieldRef = React.createRef();

    this.closeOverlayClick = this.closeOverlayClick.bind(this);
  }

  closeOverlayClick() {
    const searchFieldRef = this.searchOverlayFieldRef.current;
    
    if (searchFieldRef) {
      searchFieldRef.value = '';
    }
    
    this.setState({ searchExpanded: false });
  }

  render() {
    return (
      <>
      <NavigationOverlay
        expanded={this.state.navigationExpanded}
        closeOverlayClick={() => this.setState({ navigationExpanded: false })}
        launchSearch={() => this.setState({ searchExpanded: true })}
      />
      <SearchOverlay
        expanded={this.state.searchExpanded}
        closeOverlayClick={this.closeOverlayClick}
        searchOverlayFieldRef={this.searchOverlayFieldRef}
      />
      <header
        className='print-headline'
      >
        <img className="masthead" src={masthead} alt="The Public Domain Review" />
      </header>
      <header
        className={`site-header ${(this.props.sticky) ? 'scrolled' : ''}`}
        role="banner"
      >
        <div className="top-row page-width" ref={this.props.topRowRef}>
          <div className="search-launcher">
            <button
            aria-label="Search"
              onClick={() => {
                this.setState({ searchExpanded: true });
                setTimeout(() => this.searchOverlayFieldRef.current.focus(), 100);
              }}
            >
              { SearchSvg }
            </button>
          </div>
          <div className="menu-launcher">
            <button
              onClick={() => {
                this.setState({ navigationExpanded: true });
              }}
            >
              { MenuSvg }
            </button>
          </div>
          <div className="title">
            {this.props.homepage ? (
              <h1>
                <Link to="/">
                  <img className="masthead" src={masthead} alt="The Public Domain Review" />
                </Link>
              </h1>
            ): (
              <Link to="/">
                <img className="masthead" src={masthead} alt="The Public Domain Review" />
              </Link>
            )}
          </div>
          <div className="shopping-bag-launcher">
            <ShoppingBag />
          </div>
        </div>
        <div className="bottom-row page-width">
          <div className="left-block">
            <div className="search-launcher">
              <button
                aria-label="Search"
                onClick={() => {
                  this.setState({ searchExpanded: true });
                }}
              >
                { SearchSvg }
              </button>
            </div>
            <Link className="home-link" to="/"><img src={ PDRCircles } alt="PDR" /></Link>
            <Link
              className="support-button"
              to="/support"
            >
              Support PDR
            </Link>
          </div>
          <nav role="navigation">
            <ul>
              <li><Link to="/essays">Essays</Link></li>
              <li><Link to="/collections">Collections</Link></li>
              <li><Link to="/explore">Explore</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
            </ul>
          </nav>
          <div className="right-block">
            <SocialIcons withNewsletter={true} />
            <div className="shopping-bag-launcher">
              <ShoppingBag />
            </div>
          </div>
        </div>
      </header>
      </>
    );
  }
}

export default SiteHeader;
